objIsArr